import { api } from './api'
import {
  VaccineReference,
  VaccineReferenceListResponse,
} from '../types/vaccineReference'

export const vaccineReferenceService = {
  /**
   * Get all vaccine references
   */
  getVaccineReferences: async (): Promise<VaccineReferenceListResponse> => {
    const response = await api.get<VaccineReferenceListResponse>('/vaccine-reference')
    return response.data
  },

  /**
   * Get a specific vaccine reference by type
   */
  getVaccineReference: async (vaccineType: string): Promise<VaccineReference> => {
    const response = await api.get<VaccineReference>(`/vaccine-reference/${encodeURIComponent(vaccineType)}`)
    return response.data
  },

  /**
   * Create a new vaccine reference
   */
  createVaccineReference: async (payload: Omit<VaccineReference, 'id' | 'tenantId' | 'createdAt' | 'updatedAt'>): Promise<VaccineReference> => {
    const response = await api.post<VaccineReference>('/vaccine-reference', payload)
    return response.data
  },

  /**
   * Update an existing vaccine reference
   */
  updateVaccineReference: async (
    vaccineType: string,
    payload: Partial<Omit<VaccineReference, 'id' | 'tenantId' | 'vaccineType' | 'createdAt'>>,
  ): Promise<VaccineReference> => {
    const response = await api.put<VaccineReference>(
      `/vaccine-reference/${encodeURIComponent(vaccineType)}`,
      payload,
    )
    return response.data
  },

  /**
   * Delete a vaccine reference
   */
  deleteVaccineReference: async (vaccineType: string): Promise<void> => {
    await api.delete(`/vaccine-reference/${encodeURIComponent(vaccineType)}`)
  },
}
